"use client";

const STATUS_STYLES: Record<string, string> = {
  Pending: "bg-yellow-100 text-yellow-800",
  Compliant: "bg-green-100 text-green-800",
  NonCompliant: "bg-red-100 text-red-800",
  RequiresReview: "bg-orange-100 text-orange-800",
  Verified: "bg-green-100 text-green-800",
  Rejected: "bg-red-100 text-red-800",
  pending_consent: "bg-orange-100 text-orange-800",
};

export function ComplianceStatusBadge({
  status,
  className = "",
}: {
  status: string;
  className?: string;
}) {
  const style = STATUS_STYLES[status] || "bg-gray-100 text-gray-800";
  const label = status === "pending_consent" ? "Awaiting Consent" : status;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded ${style} ${className}`}
    >
      {label}
    </span>
  );
}

export default ComplianceStatusBadge;
